import { useCallback, useSyncExternalStore } from 'react';

/**
 * Subscribe to a CSS media query.
 *
 * Prefer this over `useScreenWidth` whenever the JavaScript needs to agree with a CSS breakpoint from
 * `~/styles/media.css` — `useScreenWidth` has its own breakpoint ladder which does not match those.
 *
 * ```ts
 * const isMobile = useMediaQuery(breakpoints.small);
 * ```
 */
export const useMediaQuery = (query: string) => {
  const subscribe = useCallback(
    (onStoreChange: () => void) => {
      const mediaQueryList = window.matchMedia(query);
      mediaQueryList.addEventListener('change', onStoreChange);

      return () => mediaQueryList.removeEventListener('change', onStoreChange);
    },
    [query],
  );

  return useSyncExternalStore(subscribe, () => window.matchMedia(query).matches);
};
